import React from 'react';
import { useOutletContext } from 'react-router-dom';
import Chiclet from '../components/Chiclet/Chiclet';
import Loading from '../components/Loading/Loading';
import { Application } from '../types';

interface DashboardContext {
  applications: Application[];
  isLoading: boolean;
  error: Error | null;
}

const Dashboard: React.FC = () => {
  const { applications, isLoading, error } = useOutletContext<DashboardContext>();

  if (isLoading && (!applications || applications.length === 0)) {
    return <Loading />;
  }

  return (
    <div className="container mt-5">
      <div className="d-flex justify-content-between align-items-center">
          <h2>Applications</h2>
      </div>
      
      {error && <div className="alert alert-danger mt-3">Error: Could not fetch data from the API. Please ensure the backend is running and accessible.</div>}
      <hr />
      {applications && applications.length > 0 ? (
        <div className="chiclet-grid">
          {applications.map((app: Application) => (
            <Chiclet key={app.id} app={app} />
          ))}
        </div>
      ) : (
        !isLoading && <p>You don't have access to any applications yet, or there was an issue loading them.</p>
      )}
    </div>
  );
};

export default Dashboard;
